/**
 * Reduce fotografías antes de enviarlas al servidor.
 * Mantiene las proporciones y convierte a JPEG.
 */
export const optimizeImage = async (file) => {
  if (!file || !file.type.startsWith("image/")) {
    throw new Error("El archivo no es una imagen válida.");
  }

  const imageUrl = URL.createObjectURL(file);

  try {
    const image = new Image();

    await new Promise((resolve, reject) => {
      image.onload = resolve;
      image.onerror = reject;
      image.src = imageUrl;
    });

    const maxDimension = 1600;
    const scale = Math.min(
      1,
      maxDimension / Math.max(image.width, image.height)
    );

    const canvas = document.createElement("canvas");
    canvas.width = Math.round(image.width * scale);
    canvas.height = Math.round(image.height * scale);

    if (!canvas.width || !canvas.height) {
      throw new Error("Dimensiones de imagen inválidas.");
    }

    const context = canvas.getContext("2d");
    if (!context) {
      throw new Error("No se pudo crear el contexto de imagen.");
    }

    context.fillStyle = "#FFFFFF";
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.drawImage(image, 0, 0, canvas.width, canvas.height);

    const blob = await new Promise((resolve, reject) => {
      canvas.toBlob(
        (result) => {
          if (result) resolve(result);
          else reject(new Error("No se pudo comprimir la imagen."));
        },
        "image/jpeg",
        0.8
      );
    });

    const filename = file.name.replace(/\\.[^.]+$/, "") + ".jpg";

    const optimized = new File([blob], filename, {
      type: "image/jpeg",
      lastModified: Date.now(),
    });

    console.info(
      "Imagen optimizada:",
      (file.size / 1024 / 1024).toFixed(2),
      "MB →",
      (optimized.size / 1024 / 1024).toFixed(2),
      "MB"
    );

    return optimized;
  } finally {
    URL.revokeObjectURL(imageUrl);
  }
};
